import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { adminGetListManagementGroupCode } from "@services/list-management.service";
import { getValue } from "@utils/lodash";
// import "./index.scss";
import NoAccessPage from "@components/common/NoAccess";
import CommonBulkUpload from "@components/BulkUpload";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";

export default function Tasks(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [view, setView] = useState("grid");
  const [dropdownOptions] = useState([
    { value: "COMPLIANCE_TASK", label: "Compliance" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getData();
      setView(
        getValue(localStorage, `c-view`, "")
          ? getValue(localStorage, `c-view`, "")
          : "grid"
      );
    }
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    try {
      setIsLoading(true);
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        setComplianceTypeList(
          list.filter((item: object) => getValue(item, `is_active`, false))
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    localStorage.setItem("c-view", view);
    setView(view);
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_pe_compliance"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center">
            {/* <h4 className="dashbaord-wrapper__header-title">Compliance</h4> */}
            <div className="d-flex align-items-center">
              
              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Activities
                </h6>
                <h4 className="dashbaord-wrapper__header-title">PE Compliance</h4>
              </div>
            </div>

            <div className="d-flex align-items-center sub-header-icons-left-line-seperator sub-header-icons-holder">
              {getValue(props, `permissions`, []).includes("update") && (
                <div style={{margin: "0 2px"}}>
                  {/* <CommonBulkUpload
									type={`compliance`}
									url="
								https://asccuriodata.s3.ap-south-1.amazonaws.com/documents/Back_dated_task_import_format.xlsx
								"
								/> */}
                  <BulkUploadDropdown
                    url={
                      "https://asccuriodata.s3.ap-south-1.amazonaws.com/documents/Back_dated_task_import_format.xlsx"
                    }
                    dropdownOptions={dropdownOptions}
                  />
                </div>
              )}
              <div className=" ms-0 ">
                <div
                  className="icons-btn p-0"
                  onClick={() =>
                    handleChangeView(view === "list" ? "grid" : "list")
                  }
                >
                  <img
                    src={`/images/${view === "list" ? "grid" : "list"}.png`}
                    style={{ height: "30px", width: "30px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={`main-page-layout-wrapper`}>
            <div className="compliance-wrapper m-auto pb-5">
              <div className="compliance-banner d-flex align-items-center justify-content-around">
                {/* <img
                  src="/images\tasks\banner-image-1.svg"
                  className="img-fluid"
                /> */}
                {/* <div className="compliance-wrapper__heading text-center">
                  <h2 className="compliance-wrapper__title">
                    Automated Statutory Compliance Management and Online Statutory
                    Audits
                  </h2>
                </div> */}
                {/* <img
                  src="/images/tasks/banner-image-2.svg"
                  className="img-fluid"
                /> */}
              </div>
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : getValue(complianceTypeList, `length`, 0) > 0 ? (
                view === "grid" ? (
                  <div className="compliance-wrapper__categories">
                    {complianceTypeList.map((categoriesObj, index: any) => {
                      return (
                        <div
                          className="compliance-wrapper__categories-details cursor-pointer"
                          key={index}
                        >
                          <NavLink
                            to={`/activities/task/compliance/list/${getValue(
                              categoriesObj,
                              `id`,
                              ""
                            )}`}
                          >
                            <img
                              src={`/images/tasks/icons/image-${
                                index + 1 < 9 ? index + 1 : 5
                              }.svg`}
                              className="img-fluid w-100"
                            />
                            <h4 className="compliance-wrapper__categories-title align-center">
                              {getValue(categoriesObj, `text`, "")}
                            </h4>
                            <p className="compliance-wrapper__categories-text">
                              {getValue(categoriesObj, `text`, "")}
                            </p>
                          </NavLink>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className={`compliance-wrapper__categories-list`}>
                    {complianceTypeList.map((categoriesObj, index: any) => {
                      return (
                        <div
                          className={`compliance-wrapper__categories-list-details`}
                          key={index}
                        >
                          <NavLink
                            to={`/activities/task/compliance/list/${getValue(
                              categoriesObj,
                              `id`,
                              ""
                            )}`}
                          >
                            <div className="d-flex mb-3 ">
                              <img
                                src={`/images/tasks/icons/image-${
                                  index + 1 < 9 ? index + 1 : 5
                                }.svg`}
                                className="img-fluid w-100"
                              />
                              <div className="compliance-wrapper__categories-list-details-view">
                                <h4 className="compliance-wrapper__categories-list-title">
                                  {getValue(categoriesObj, `text`, "")}
                                </h4>
                                <p className="compliance-wrapper__categories-list-text">
                                  {getValue(categoriesObj, `text`, "")}
                                </p>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
                  </div>
                )
              ) : (
                <Notfound />
              )}
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
